/* eslint-disable eqeqeq */
import { Formik } from "formik";
import { useState, useEffect, useCallback } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { LabelWithValue } from "../components/label-with-value";
import { addYear, getDay, getDiffDay, getLocalDate, setUtcTime } from "../../../helper/dateTimeHelper";
import DateRangeSelect from "../../procedure/meeting/range-time-select/DateRangeSelect";
import { CreateNotification } from "../../../components/notifier";
import Select from "react-select";
import { buildPeopleJsonFromPicker, getIdsByBuildDataJson } from "../../../services/util";
import { FileService } from "../../../services/file/file.service";
import { PeoplePicker, PersonType } from "@microsoft/mgt-react";
import { composeStatus, documentInfoStatus, documentStatus } from "../../../constants/statusConstants";
import { getTitleForEffectiveBaseOnStatus, getLabelStatus, createFileContentForEditor } from "../util";
import { InputCheckbox } from "../../../components/input/checkbox";
import { DocumentContentService } from "../../../services/document/document-content.service";
import { useRouteMatch } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { useUpdateDocumentInfo } from "../hooks/content-mutation/use-update-document-info";
import { useDocumentTags } from "../../setting/document/document-tags/hooks/useDocumentTags";
import { Select as AntSelect, Spin, TreeSelect } from "antd";
import { useDocumentType } from "../hooks";
import { useDocDepartments } from "../../setting/document/document-department/hooks/use-doc-departments";
import { AttachFileButton, ViagsUpload } from "../../../components";
import { useViagsUpload } from "../../procedure/human-organization/absence-letter/hooks/use-viags-upload";

const sqmsDocCodeOptions = [
  {
    pDepartment: "ATCL",
    label: "V.QMS",
    value: "V.QMS",
  },
  {
    pDepartment: "ATCL",
    label: "V.SMS",
    value: "V.SMS",
  },
  {
    pDepartment: "ATCL",
    label: "V.SOP",
    value: "V.SOP",
  },
  {
    pDepartment: "ATCL",
    label: "V.SSM",
    value: "V.SSM",
  },
  {
    pDepartment: "TCNL",
    label: "V.HRM",
    value: "V.HRM",
  },
  {
    pDepartment: "KHĐT",
    label: "V.SPM",
    value: "V.SPM",
  },
  {
    pDepartment: "CNTT",
    label: "V.IMM",
    value: "V.IMM",
  },
  {
    pDepartment: "TTĐT",
    label: "V.TMM",
    value: "V.TMM",
  },
  {
    pDepartment: "TTĐT",
    label: "V.TPM",
    value: "V.TPM",
  },
  {
    pDepartment: "KDTT",
    label: "V.MSM",
    value: "V.MSM",
  },
];

const docSectionsOptions = [
  {
    label: "P - CHƯƠNG",
    value: "P",
  },
  {
    label: "A - PHỤ LỤC",
    value: "A",
  },
  {
    label: "F - BIỂU MẪU",
    value: "F",
  },
];

const EditDocumentDetailInfo = (props: any) => {
  const { onClose, onUpdated, data, folderId, listId, isCustomEditor, copiedTemplateId } = props;
  const today = new Date();
  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(addYear(today, 5));
  const [minDate, setMinDate] = useState(today);
  const [isNew, setIsNew] = useState(false);
  const [loading, setLoading] = useState(true);
  const [docEditors, setDocEditors] = useState([]);
  const [fileAssignedTos, setFileAssignedTos] = useState([]);
  const [approvedBy] = useState([]);
  const [docStatus, setDocStatus] = useState<any>();
  const [approvedDate, setApprovedDate] = useState(new Date());
  const [documentStatusList, setDocumentStatusList] = useState<any>([]);
  const [statuslable, setStatusLabel] = useState<any>();
  //react-tag
  const [tags, setTags] = useState<any[]>([]);
  const { id } = useRouteMatch().params as any;
  const [stateSubmit, setStateSubmit] = useState<(values: any) => Promise<void> | void>(() => () => {});
  const { mutate, isLoading: isUpdateLoading } = useUpdateDocumentInfo();
  const queryClient = useQueryClient();
  const { dataOptions, getTagLabel } = useDocumentTags();
  const { data: docTypeOptions, isLoading: isDocTypeLoading } = useDocumentType();
  const { getDepartmentsByDocType, isLoading: isDocDepartmentLoading } = useDocDepartments();
  const [departmentOptions, setDepartmentOptions] = useState<any[]>(getDepartmentsByDocType());
  const { mapUploadResponse } = useViagsUpload();

  async function handleOnSubmit(values: any) {
    if (!values.docCode) {
      CreateNotification({
        title: "Thông báo",
        body: "Vui lòng nhập thông tin mã tài liệu!",
        icon: "/icons/warning.png",
      });
      return;
    }
    if (!values.Title) {
      CreateNotification({ title: "Thông báo", body: "Vui lòng nhập tên tài liệu!", icon: "/icons/warning.png" });
      return;
    }
    if (docStatus?.value !== documentStatus.new.value && fileAssignedTos.length === 0 && isCustomEditor) {
      CreateNotification({ title: "Thông báo", body: "Vui lòng chọn người thực hiện!", icon: "/icons/warning.png" });
      return;
    }
    setLoading(true);
    const fields = data.IsCustomEditor
      ? {
          effectiveFrom: setUtcTime(getDay(startDate)),
          effectiveTo: setUtcTime(getDay(endDate)),
          docNotes: values.reasonForChange,
          docEditionVersion: values.docEditionVersion,
          docPublicVersion: values.docPublicVersion,
          docPublishViewVersion: values.docPublishViewVersion,
          docCode: values.docCode,
          docOrder: values.docOrder,
          docPublicDepartmentLookupId: values.docPublicDepartment,
          fileAssignedTo: buildPeopleJsonFromPicker(fileAssignedTos),
          approvedBy: buildPeopleJsonFromPicker(approvedBy),
          docEditors: buildPeopleJsonFromPicker(docEditors),
          docTypeLookupId: values.docType.value,
          subInfo: values.subInfo,
          approvedDate: setUtcTime(getDay(approvedDate)),
          docStatusId: docStatus?.id,
          docStatusValue: docStatus?.value,
          docStatus: docStatus?.label,
          Title: values.Title,
          IsConvertToPDF: values.IsConvertToPDF,
          Tags: JSON.stringify(tags),
          IsCustomEditor: isCustomEditor,
          docEditTemp: values.docEditTemp,
          fileAttachment: !values.fileAttachment ? undefined : JSON.stringify(values.fileAttachment),
          //docAreas: buildPeopleJsonFromdocAreas(docAreas)
        }
      : {
          effectiveFrom: setUtcTime(getDay(startDate)),
          effectiveTo: setUtcTime(getDay(endDate)),
          docNotes: values.reasonForChange,
          docEditionVersion: values.docEditionVersion,
          docPublishViewVersion: values.docPublishViewVersion,
          docCode: values.docCode,
          docOrder: values.docOrder,
          docPublicDepartmentLookupId: values.docPublicDepartment,
          docTypeLookupId: values.docType.value,
          subInfo: values.subInfo,
          approvedDate: setUtcTime(getDay(approvedDate)),
          // docStatusId: docStatus?.id || documentStatus.new.id,
          // docStatusValue: docStatus?.value || documentStatus.new.value,
          // docStatus: docStatus?.label || documentStatus.new.label,
          Title: values.Title,
          IsConvertToPDF: values.IsConvertToPDF,
          Tags: JSON.stringify(tags),
          docEditTemp: values.docEditTemp,
          fileAttachment: !values.fileAttachment ? undefined : JSON.stringify(values.fileAttachment),
        };

    try {
      if (isNew) {
        const fileName = `${crypto.randomUUID()}.html`;
        const file = await createFileContentForEditor("", fileName);
        const result = await FileService.createFile(file, folderId, listId);
        if (result) {
          const fileId = result.id;
          const infoPromises: any[] = [];
          if (copiedTemplateId) {
            infoPromises.push(DocumentContentService.cloneFromTempalteToFile(copiedTemplateId, fileId));
          }
          const documentInfo = await FileService.createFileDocumentInfo(result, folderId, fields);
          Promise.all(infoPromises);
          onUpdated(documentInfo);
          setLoading(false);
        }
      } else {
        mutate(
          {
            id: data.id + "",
            body: fields,
          },
          {
            onError() {},
            async onSuccess(response) {
              queryClient.invalidateQueries({ queryKey: ["document-info"] });
              await FileService.updateFileInfoFromDocumentInfo(data.docId, fields);
              onUpdated(response, isUpdateLoading);
              CreateNotification({
                title: "Thành công",
                body: `Cập nhật thông tin thành công.`,
                icon: "/icons/success.png",
              });
            },
          },
        );
      }
    } catch (error: any) {
      setLoading(false);
      CreateNotification({
        title: "Không thể tạo thông tin tài liệu",
        body: error.toString(),
        icon: "/icons/warning.png",
      });
      console.log(error);
    }
  }

  const onStartDateChange = (date: any) => {
    const newDate = new Date(date);
    setStartDate(newDate);
    const days = getDiffDay(getLocalDate(newDate), getLocalDate(getDay(endDate)));
    if (days < 0) {
      setEndDate(newDate);
    }
    setTimeout(() => setMinDate(newDate), 0);
  };

  const onEndDateChange = (date: any) => {
    setEndDate(new Date(date));
  };

  const handleFileAssignedTosSelectionChanged = (e: any) => {
    setFileAssignedTos(e.target.selectedPeople);
    if (docStatus?.id === 2) setDocEditors(e.target.selectedPeople);
  };

  const handleStatusChanged = (documentStatus: any) => {
    setDocStatus(documentStatus);
    const label = getLabelStatus(documentStatus.id);
    setStatusLabel(label);
  };

  useEffect(() => {
    id != 0
      ? setDocumentStatusList(Object.values(composeStatus))
      : setDocumentStatusList(Object.values(documentInfoStatus));

    setIsNew(data && data?.id <= 0);

    if (data && data.IsCustomEditor) {
      setStatusLabel(data.docStatus);

      if (data.effectiveFrom || data.effectiveTo) {
        const startDate = data.effectiveFrom && new Date(data.effectiveFrom);
        const endDate = data.effectiveTo && new Date(data.effectiveTo);
        setStartDate(startDate);
        setEndDate(endDate);
      }

      if (data.approvedDate) setApprovedDate(new Date(data.approvedDate));

      const status =
        documentStatusList.find((s: any) => s.id === data.docStatusId) ||
        (id != 0 ? documentStatus.compose : documentStatus.new);
      setDocStatus(status);
      setStatusLabel(status.label);
    }
    setTags(data.Tags ? data.Tags.filter((e: any) => !!getTagLabel(e)) : []);
    setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const getPublicDepartment = useCallback(
    (deptId: string) => {
      if (!getDepartmentsByDocType) return null;
      return departmentOptions?.find((e: { label: string; value: string }) => e.value === deptId);
    },
    [departmentOptions, getDepartmentsByDocType],
  );

  if (loading) return <Spin />;

  return (
    <Formik
      onSubmit={stateSubmit}
      initialValues={{
        reasonForChange: data?.docNotes || "",
        subInfo: data?.subInfo || "",
        docPublicVersion: data?.docPublicVersion || 0,
        docEditionVersion: data?.docEditionVersion || 0,
        docPublishViewVersion: data?.docPublishViewVersion || 0,
        docEditTemp: data?.docEditTemp || "",
        docOrder: data?.docOrder || 0,
        docCode: data?.docCode || "",
        docPublicDepartment: data?.docPublicDepartmentLookupId ? data?.docPublicDepartmentLookupId : null,
        docEditors: data?.docEditors || null,
        approvedBy: data?.approvedBy || null,
        approvedDate: data?.approvedDate || null,
        docType: { value: data?.docTypeId || null, label: data?.docType || null },
        Title: data?.Title || "",
        IsConvertToPDF: data?.IsConvertToPDF,
        docAreas: data?.docAreas || "",
        fileAttachment: data?.fileAttachment || [],
        sqmsDocCode: null,
        docSections: null,
      }}
    >
      {({ handleSubmit, setFieldValue, handleChange, values, getFieldProps }) => (
        <Form noValidate onSubmit={handleSubmit}>
          <Modal.Header>
            <Modal.Title>{id == 0 ? "Tạo thông tin tài liệu" : "Cập nhật thông tin tài liệu"}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="py-4 px-4">
            <Row>
              <div className="card w-100 fw-bold" style={{ width: "18rem" }}>
                <div className="card-header">Thông tin</div>
                <div className="card-body w-70">
                  <LabelWithValue
                    label={
                      <span>
                        Tên tài liệu <span style={{ color: "red" }}>(*)</span>
                      </span>
                    }
                    value={""}
                  />
                  <Form.Control
                    as="textarea"
                    rows={1}
                    type="text"
                    placeholder=""
                    name="Title"
                    value={values.Title}
                    onChange={handleChange}
                  />

                  {/* day la card thong tin */}
                  <div className="row">
                    <div className="col-6">
                      <LabelWithValue label={"Loại tài liệu:"} value={""} />
                      <Select
                        options={docTypeOptions}
                        value={values?.docType}
                        isLoading={isDocTypeLoading}
                        placeholder={"Vui lòng chọn loại tài liệu"}
                        onChange={(data) => {
                          setFieldValue("docType", data);
                          setFieldValue("docPublicDepartment", null);
                          setFieldValue("sqmsDocCode", null);
                          setDepartmentOptions(getDepartmentsByDocType(data?.value));
                        }}
                        className="custom-select-container py-0"
                      />
                    </div>

                    <div className="col-6">
                      <LabelWithValue label={"Bộ phận ban hành:"} value={""} />
                      {/* <Select
                          options={publicDeparments}
                          value={values.docPublicDepartment}
                          onChange={(data) => {
                            setFieldValue("docPublicDepartment", data);
                          }}
                          className="custom-select-container py-0"
                        ></Select> */}
                      <TreeSelect
                        treeData={departmentOptions}
                        treeDataSimpleMode={{
                          id: "Id",
                          pId: "CompanyId",
                          //rootPId can be set too
                        }}
                        placeholder={"Vui lòng chọn bộ phận"}
                        value={values.docPublicDepartment}
                        treeNodeLabelProp="Name"
                        treeNodeFilterProp="Name"
                        className="w-full"
                        loading={isDocDepartmentLoading}
                        onChange={(data) => {
                          setFieldValue("docPublicDepartment", data);
                          const docTypeValue = getFieldProps("docType").value;
                          if (docTypeValue.value != "1" && docTypeValue.value != "2") return;
                          const docTypeAbbr = docTypeValue.value == "1" ? "NB" : "BN";
                          const department = getPublicDepartment(data);
                          const docCode = `${docTypeAbbr}/${department.DeptCode}/${id}`;
                          setFieldValue("sqmsDocCode", null);
                          setFieldValue("docCode", docCode);
                        }}
                        showSearch
                        size="large"
                        treeDefaultExpandAll={true}
                      />
                    </div>
                    {(values.docType.value === "58" || values.docType.value === "5") && (
                      <>
                        <div className="col-6">
                          <LabelWithValue label={"Mã hiệu tài liệu:"} value={""} />
                          <Select
                            options={sqmsDocCodeOptions.filter(
                              (e) => e.pDepartment === getPublicDepartment(values.docPublicDepartment)?.Abbr,
                            )}
                            onChange={(data) => {
                              setFieldValue("sqmsDocCode", data);
                            }}
                            className="custom-select-container py-0 w-full"
                            placeholder="Chọn mã hiệu tài liệu"
                            value={values.sqmsDocCode}
                          />
                        </div>
                        <div className="col-6">
                          <LabelWithValue label={"Mục tài liệu:"} value={""} />
                          <Select
                            className="custom-select-container py-0 w-full"
                            placeholder="Chọn mục tài liệu"
                            options={docSectionsOptions}
                            value={values.docSections}
                            onChange={async (value) => {
                              if (!values.sqmsDocCode) {
                                CreateNotification({
                                  title: "Thông báo",
                                  body: "Anh/Chị vui lòng chọn mã hiệu trước !",
                                  icon: "/icons/warning.png",
                                });
                                return;
                              }
                              setFieldValue("docSections", value);
                              const docTypeValue = getFieldProps("docType").value;
                              if (docTypeValue.value !== "58" && docTypeValue.value !== "5") return;
                              const sqmsDocCode = values.sqmsDocCode as any;
                              const prefixDocCode = `${sqmsDocCode?.value}-${value?.value}`;
                              let count = 0;
                              if (folderId) {
                                const results = await FileService.getChild(folderId, "", true);
                                if (results.count > 0) {
                                  const matchPrefixDocCode = results.data.filter((e: { docCode: string }) =>
                                    e.docCode?.includes(prefixDocCode),
                                  );
                                  count = matchPrefixDocCode.length;
                                }
                              } else {
                                const file = await FileService.getFile(data?.fileId);
                                if (file?.parentId) {
                                  const results = await FileService.getChild(file.parentId, "", true);
                                  if (results.count > 0) {
                                    const matchPrefixDocCode = results.data.filter((e: { docCode: string }) =>
                                      e.docCode?.includes(prefixDocCode),
                                    );
                                    count = matchPrefixDocCode.length;
                                  }
                                }
                              }
                              const stringCount = count.toString().padStart(2, "0");
                              const docCode = prefixDocCode + stringCount;
                              setFieldValue("docCode", docCode);
                            }}
                          />
                        </div>
                      </>
                    )}
                    <div className="col-6">
                      <LabelWithValue
                        label={
                          <span>
                            Mã tài liệu<span style={{ color: "red" }}>(*)</span>
                          </span>
                        }
                        value={""}
                      />
                      <Form.Control
                        as="textarea"
                        rows={1}
                        type="text"
                        placeholder=""
                        name="docCode"
                        value={values.docCode}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-6">
                      <LabelWithValue label={"Vị trí:"} value={""} />
                      <Form.Control
                        size="lg"
                        className="py-1 px-2 h-auto"
                        type="number"
                        placeholder=""
                        name="docOrder"
                        value={values.docOrder}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-12">
                      <LabelWithValue label={"Mô tả:"} value={""} />
                      <Form.Control
                        as="textarea"
                        rows={2}
                        type="text"
                        placeholder=""
                        name="subInfo"
                        value={values.subInfo}
                        onChange={handleChange}
                      />
                    </div>

                    <Col xs="12">
                      <LabelWithValue label={"Chủ đề: "} value={""} />
                      <AntSelect
                        options={dataOptions}
                        value={tags}
                        onChange={(e: any) => setTags(e)}
                        placeholder="Vui lòng chọn chủ đề"
                        mode="multiple"
                        style={{ width: "100%" }}
                        size="large"
                        showSearch
                        optionLabelProp="label"
                        // children? options? label?
                        optionFilterProp="children"
                        filterOption={(input, option) => {
                          if (!option || !option.label) return false;
                          return (option.label as string).toLowerCase().indexOf(input.toLowerCase()) >= 0;
                        }}
                      />
                    </Col>
                    <Col xs="6" className="p-3">
                      <LabelWithValue label={"File đính kèm: "} value={""} />
                      <ViagsUpload
                        name="fileAttachment"
                        onChange={(fileInfo: any) => {
                          const eAttachments = mapUploadResponse(fileInfo.fileList);
                          setFieldValue("fileAttachment", eAttachments);
                        }}
                        defaultFileList={values.fileAttachment}
                      >
                        <AttachFileButton />
                      </ViagsUpload>
                    </Col>
                  </div>
                </div>
              </div>
              {/*day la card tinh trang */}
              <div className="card w-100">
                <div className="card-header">Tình trạng</div>
                <div className="card-body w-70">
                  <div className="row">
                    {data.IsCustomEditor && (
                      <>
                        <div className="col-6">
                          <LabelWithValue label={"Tình trạng:"} value={""} />
                          <Select
                            options={documentStatusList}
                            value={docStatus}
                            onChange={handleStatusChanged}
                            className="custom-select-container"
                          />
                        </div>

                        <div className="col-6">
                          <LabelWithValue
                            label={
                              <span>
                                {statuslable}{" "}
                                {docStatus?.value !== documentStatus.new.value && (
                                  <span style={{ color: "red" }}>(*)</span>
                                )}
                              </span>
                            }
                            value={""}
                          />
                          <div className="people_picker-custom">
                            <PeoplePicker
                              className="people-picker"
                              placeholder={`Nhập phòng hoặc nhân viên được ${statuslable.toLowerCase()} tài liệu`}
                              defaultSelectedUserIds={getIdsByBuildDataJson(data?.fileAssignedTo)}
                              type={PersonType.any}
                              selectionChanged={handleFileAssignedTosSelectionChanged}
                            />
                          </div>
                        </div>
                      </>
                    )}
                    {/* {data.IsCustomEditor && (
                      <div className="col-3">
                        <LabelWithValue label={"Lần ban hành thứ:"} value={""} />
                        <Form.Control
                          size="lg"
                          className="py-1 px-2 h-auto"
                          type="number"
                          disabled={data.IsCustomEditor}
                          placeholder=""
                          name="docPublicVersion"
                          value={values.docPublicVersion}
                          onChange={handleChange}
                        />
                      </div>
                    )} */}
                    <div className={"col-4"}>
                      <LabelWithValue label={"Lần ban hành:"} value={""} />
                      <Form.Control
                        size="lg"
                        className="py-1 px-2 h-auto"
                        type="number"
                        placeholder=""
                        name="docPublishViewVersion"
                        value={values.docPublishViewVersion}
                        onChange={handleChange}
                      />
                    </div>
                    <div className={"col-4"}>
                      <LabelWithValue label={"Lần sửa đổi:"} value={""} />
                      <Form.Control
                        size="lg"
                        className="py-1 px-2 h-auto"
                        type="number"
                        placeholder=""
                        name="docEditionVersion"
                        value={values.docEditionVersion}
                        onChange={handleChange}
                      />
                    </div>
                    <div className={"col-4"}>
                      <LabelWithValue label={"Sửa đổi tạm thời:"} value={""} />
                      <Form.Control
                        size="lg"
                        className="py-1 px-2 h-auto"
                        type="text"
                        placeholder=""
                        name="docEditTemp"
                        value={values.docEditTemp}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-12">
                      <LabelWithValue label={getTitleForEffectiveBaseOnStatus(data?.docStatusId)} value={""} />
                      <DateRangeSelect
                        onStartDateSelect={onStartDateChange}
                        onEndDateSelect={onEndDateChange}
                        startDate={startDate}
                        minDate={minDate}
                        endDate={endDate}
                      />
                    </div>
                    <div className="col-6 py-3">
                      {false && (
                        <InputCheckbox
                          name="IsConvertToPDF"
                          label="Chuyển đổi thành PDF khi ban hành"
                          onTouched={() => true}
                          onChange={(e) => (values.IsConvertToPDF = e)}
                          value={values.IsConvertToPDF}
                          defaultValue={true}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={onClose} variant="secondary" size="lg">
              Hủy
            </Button>
            <Button
              type="submit"
              variant="info"
              onClick={() => setStateSubmit(() => handleOnSubmit)}
              disabled={isUpdateLoading}
              size="lg"
              style={{ marginRight: "60px" }}
            >
              {id == 0 ? "Tạo mới" : "Cập nhật"}
            </Button>
          </Modal.Footer>
        </Form>
      )}
    </Formik>
  );
};

export default EditDocumentDetailInfo;
